import {DatePipe} from '@angular/common';
import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {CartTypes, RouterLinks} from '../../constants';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {ShoppingCartQuery} from '../../questions/state/shopping-cart-query';
import {SidebarService} from '../../services/sidebar-service';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {ShoppingCartStore} from '../../questions/state/shopping-cart-store';
import {Router} from '@angular/router';
import {Question} from '../../models/underwriter.model';

declare var $: any;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Output() showEditModal = new EventEmitter<any>();

  activeItem: any;
  subscription: Subscription;
  shoppingCartItems: any[] = [];
  groups: any[] = [];
  cart_type: any;
  CartType = CartTypes;
  event_details: any = null;
  selectedItem: any;
  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  RouterLinks = RouterLinks;

  constructor(
    private shoppingCartQuery: ShoppingCartQuery,
    private shoppingCartStore: ShoppingCartStore,
    private sidebarService: SidebarService,
    public questionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private datePipe: DatePipe,
    private router: Router,
    private el: ElementRef
  ) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
    this.subscription = sidebarService.updateSidebar()
      .subscribe((update: any) => {
        this.groups = [];
        this.event_details = null;
        this.activeItem = this.shoppingCartQuery.getActive();
        this.populateSidebar();
      });
  }

  ngOnInit(): void {
    this.shoppingCartItems = [];
    this.groups = [];
    this.populateSidebar();

    this.questionService.summaryData
      .subscribe(v => {
        if (v) {
          this.groups = [];
          this.populateSidebar();
          this.questionService.setSummaryDataObservable(false);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.previousValue !== changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
    }
  }

  getItemStatus(progress: any, hasSkipped: any): string {
    if (progress < 1) {
      return 'pending';
    } else {
      if (hasSkipped === 1) {
        return 'pending';
      } else {
        return 'complete';
      }
    }
  }

  formatItemDescription(description: string, type: number): string {
    const splitDescription = description?.split('|');
    if (splitDescription) {
      switch (type) {
        case 1:
          return splitDescription[0];
        case 2:
          return splitDescription[1];
        default:
          return '';
      }
    }
    return '';
  }

  formatGroup(group: string): any {
    return this.camelize(this.replaceUnderscores(group));
  }

  replaceUnderscores(str: string): any {
    return str.replace(/_/g, ' ');
  }

  camelize(s: string): any {
    return s.replace(/\w+/g,
      (w: any) => w[0].toUpperCase() + w.slice(1).toLowerCase());
  }

  buildTooltip(tip: any): any {
    let tips = '';
    try {
      JSON.parse(tip).forEach(t => {
        tips += t.item_name + ' ' + this.questionService.accounting?.formatMoney(t.item_value) + ' /' + t.frequency;
      });
    } catch {
    }

    return tips;
  }

  getEntryType(entry_type: string): any {
    const cartItems = this.shoppingCartQuery.getAll();
    return cartItems?.filter(entry => entry?.entry_type === entry_type);
  }

  populateSidebar(): any {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
    if (this.sessionDetails?.flow_type_id === 2) {
      this.cart_type = CartTypes.claim;
    } else {
      this.cart_type = CartTypes.acquisition;
    }
    const cartItems = this.shoppingCartQuery.getAll();
    
    const groupsDict: {} = cartItems?.reduce((r: any, a: any) => {
      r[a.class_id] = [...r[a.class_id] || [], a];
      return r;
    }, {});

    const groupsArray = Object.entries(groupsDict);

    groupsArray?.forEach((item: any) => {
      let items = [];
      const entries = item[1];

      entries?.forEach((entry: any) => {
        const stageName = entry?.entry_type;

        let status = 'inactive';
        if (entry.active === 1) {
          status = 'active';
        }
        if (entry.progress === 1) {
          status = 'complete';
        }
        switch (stageName) {
          case 'event_details':
            items = [];
            const event_description = entry?.description?.split('|');
            if (event_description) {
              var location = undefined;
              var date = undefined;
              const name = event_description[0];
              const dateSplit = event_description[2]?.split('-');

              if(dateSplit?.length === 3){
                const year = dateSplit[0];
                const month = dateSplit[1];
                const day = dateSplit[2];

                const startDate = new Date(+year, +month - 1, +day);
                if (!isNaN(startDate.getTime())) {
                  date = this.datePipe.transform(startDate, 'MMM dd, yyyy');
                }
              }

              if(event_description[1]){
                try {
                  const address = JSON.parse(event_description[1]);
                  location = `${address.streetAddress}, ${address.suburb}, ${address.city}, ${address.postalCode}`;
                } catch (e) {
                  location = event_description[1];
                }
              }

             // if(name && location && date)

              items.push({name: name, location: location, date: date});

            }
            const ev_group = {group_type: this.getEntryType('event_details_header')[0]?.description, entry_type: stageName, items, status, percentage: `${entry.progress * 100}%`};
            this.event_details = ev_group;
            break;
          case 'class_header':
            items = this.getItemsByClassId(entries, entry.class_id);
            const class_group = {group_type: stageName, group_class: entry.class_id, group_name: entry.class_name, items, status, percentage: `${entry.progress * 100}%`};
            this.groups.push(class_group);
            break;
          case 'personal_details':
            const personal_group = {group_type: this.getEntryType('personal_header')[0]?.description, description: entry.description, status, percentage: `${entry.progress * 100}%`};
            this.event_details = personal_group;
            break;
          default:
            break;
        }
      });
    });
    setTimeout(() => {
      $('[data-toggle="popover"]').popover();
      this.el.nativeElement.querySelector('.progress-tree__detail--selected')?.scrollIntoView({behavior: 'smooth', block: 'start'});
    }, 500);
  }

  getItemsByClassId(entries: any[], class_id: number): any {
    return entries?.filter((entry: any) =>
      entry.entry_type === 'class_item' && entry.class_id === class_id);
  }

  getPercentage(value: number): any {
    return `${value * 100}%`;
  }

  getStages(): any {
    return [
      {stage_name: 'Event Details'},
      {stage_name: 'Damage Report'},
      {stage_name: 'Police Report'}
    ];
  }

  isActive(item: any): any {
    return this.activeItem?.shoppingcart_id === item.shoppingcart_id;
  }

  getTotalPremium(groups: any[]): any {
    const items: any[] = [];
    groups.forEach((group: any) => {
      group.items.forEach((item: any) => {
        items.push(item);
      });
    });

    let sum = 0;
    items.forEach((item: any) => {
      sum += item.premium;
    });
    return sum;
  }

  activeClass(item: any): any {
    return this.isActive(item) === true ? ' is-active' : '';
  }

  activateItem(item: any): any {
    $('.progress-tree__detail').each((i: any, c: any) => {
      $(c).removeClass('is-active');
    });
    // this.itemStore.setActive(item.id);
    $(`#${item.shoppingcart_id}`).addClass('is-active');
  }

  selectDetailToggleHandler($el: any): void {
    const correctTarget = $el.hasClass('progress-tree__detail');
    if (!correctTarget) {
      return;
    }

    const $current = $('.progress-tree__detail--selected');

    if ($current.length > 0) {
      for (const item of $current) {
        item.classList.remove('is-active');
      }
    }

    if ($el.hasClass('progress-tree__detail')) {
      $el.addClass('is-active');
      // claimsFeedScrollToSelected($el)
    } else {
      $el.closest('.progress-tree__detail').addClass('is-active');
      // claimsFeedScrollToSelected($el.closest('.progress-tree__detail'))
    }
  }

  initFeedClickEventListeners(): any {
    const $divs = $('.progress-tree__detail');
    for (const item of $divs) {
      item.addEventListener('click', (e) => {
        this.selectDetailToggleHandler($(e.target));
      });
    }
  }

  editItem(item: any): void {
    this.questionService.spinner(true);
    if (this.cart_type === CartTypes.claim) {
      this.showEditModal.emit({cart_type: this.cart_type});
      setTimeout((e: any) => {
        this.questionService.spinner(false);
      }, 1000);
    } else {
      let collation: any;
      this.questionService.updatePrices(this.question?.product_id, this.question?.product_class_id, 0)
        .subscribe(x => {
          this.questionService.getPageData('quote')
            .subscribe(dataset => {

              this.product = this.questionService.getIndexData(4, dataset)[0];
              this.summary.pageDataProduct = this.product;
              this.summary.person = this.questionService.getIndexData(1, dataset)[0];
              this.collations = this.questionService.getIndexData(2, dataset);
              collation = this.collations.find(c => c.class_id === item?.class_id && c.session_item_id.toString() === item?.item_id.toString() && c.product_id === this.product?.product_id);

              console.log('item', item);
              console.log('collation', collation);
              console.log('collations', this.collations);

              this.showEditModal.emit({
                collations: this.collations,
                collation,
                product: this.product,
                person: this.summary?.person,
                path: '3'
              });
            }, error => {
              console.log(error);
              this.questionService.spinner(false);
            });
        }, () => {
          this.questionService.spinner(false);
        });
    }
  }

  editClaimsItem(item: any): void {
    if (item) {
      this.shoppingCartStore.setActive(item?.shoppingcart_id);
      this.router.navigate([`/${RouterLinks.ClaimSummaryUpdate}`]);
    }
  }

}
